import { DateTime } from 'luxon';

import {
  ApiDataSourceSpec,
  apiDataSource,
} from '@/io/datasource/ApiDatasource.ts';
import { pumpEventSchema } from '@/models/InsulinPumpEvents.ts';
import { medicalDeviceSchema } from '@/models/MedicalDeviceModel.ts';
import { insulinSchema } from '@/models/diabetes/InsulinModel.ts';
import { cz } from '@/utils/zodUtils.ts';

export class InsulinRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  getInsulin = (patientId: string, from: DateTime, to: DateTime) => {
    return this.datasource.get(
      `/practitioner/insulin/${patientId}/`,
      cz.forcedArray(insulinSchema),
      {
        params: {
          start: from.toISO(),
          end: to.toISO(),
        },
      },
    );
  };

  getActiveInsulinDevice = (
    patientId: string,
    from: DateTime,
    to: DateTime,
  ) => {
    return this.datasource.get(
      `/practitioner/insulin/${patientId}/latest-device/`,
      cz.transform(cz.noContent(medicalDeviceSchema), device =>
        device ? { device } : { device: undefined },
      ),
      {
        params: {
          start: from.toISO(),
          end: to.toISO(),
        },
      },
    );
  };

  getInsulinPumpEvents = (patientId: string, from: DateTime, to: DateTime) => {
    return this.datasource.get(
      `/practitioner/pumps/${patientId}/events/`,
      cz.forcedArray(pumpEventSchema),
      {
        params: {
          start: from.toISO(),
          end: to.toISO(),
        },
      },
    );
  };
}
